import PublicView from "./PublicView";
export default PublicView;
